import React, { createContext, useContext, useState } from "react";

const ConfirmationModalContext = createContext();

export const useConfirmationModal = () => useContext(ConfirmationModalContext);

export const ConfirmationModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [onConfirm, setOnConfirm] = useState(null);

  const openModal = (title, onConfirmCallback) => {
    setTitle(title);
    setOnConfirm(() => onConfirmCallback);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setTitle("");
    setOnConfirm(null);
  };

  const confirmAction = () => {
    if (onConfirm) onConfirm();
    closeModal();
  };

  return (
    <ConfirmationModalContext.Provider value={{ isOpen, title, openModal, closeModal, confirmAction }}>
      {children}
    </ConfirmationModalContext.Provider>
  );
};